// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__lfWxZ","tab":"ProcedureTabs_tab__1CbvN"};